import http from './httpService';

export const roleService = () => {
	return http.get('/api/roles');
};
